import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Paginator from "./Pagination";
import Check from "@material-ui/icons/Check";
import { RRMList, updateRRMactionPrice } from "../service/api";
import { Box, Button, TableSortLabel } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import moment from "moment";
import CurrencyFormat from "react-currency-format";
import { RRMApprovalTableHeading } from "../Utils/appConstants";
import SortIcon from "../assets/WebFont/sort.svg";

const useStyles = makeStyles({
  table: {
    border: "1px solid #e1e1e1",
  },
  tableRow: {
    borderBottom: "1px solid #e1e1e1",
  },
  tableHeaderRow: {
    borderTop: "1px solid #e1e1e1",
    borderBottom: "1px solid #e1e1e1",
  },
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
  },
  buttonHandle: {
    margin: '5px'
  }
});

export default function RRMApproval(props) {
  const classes = useStyles();
  const [rrmList, setRrmList] = useState([]);
  const [rrmListRows, setRrmListRows] = useState([]);
  const [updateStatus, setUpdateStatus] = useState(null);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('vin');
  const [curentDataPage, setCurrentDataPage] = useState(1);
  const [checkBoxChecked, setCheckBoxChecked] = useState(false);
  useEffect(() => {
    getRRMApprovalDetails();
  }, []);

  useEffect(() => {
    if (rrmListRows.length > 0 && curentDataPage === 1) {
      const updatedData = stableSort(rrmListRows, getComparator(order, orderBy));
      setRrmListRows(updatedData);
    }
  }, [order, orderBy]);

  async function getRRMApprovalDetails() {
    let apiResponse = await RRMList();
    apiResponse.data = apiResponse?.data.map(x => {
      return { ...x, approve: false }
    })
    setRrmListRows(apiResponse?.data?.sort((a, b) => (b?.pricedDate > a?.pricedDate) ? 1 : -1));
  }
  const openConditionReport = (VINumber, vehicleDetails) => {
    props.props.history.push("/conditionreportRequests", {
      vin: VINumber,
      pageName: "RRMApproval",
      vehicleDetails
    });
  };
  const onChangePage = (data) => {
    if (data.length > 0) {
      setRrmList(data);
    }
  };


  const handleRequestSort = (
    property
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }


  const getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  return (
    <>
      <div>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="simple table">
            <TableHead className={classes.tableHeaderRow}>
              <TableRow className={classes.tableHeadFont}>
                {curentDataPage === 1 ? RRMApprovalTableHeading.map((item) => {
                  return (
                    <TableCell>
                      <TableSortLabel
                        active={orderBy === item.id}
                        direction={orderBy === item.id ? order : 'asc'}
                        onClick={() => handleRequestSort(item.id)}
                        IconComponent={() => (
                          <img src={SortIcon} alt="sort" className="tableSortIcon" />
                        )}
                      >
                        {item.label}
                      </TableSortLabel>
                    </TableCell>
                  )
                }) : RRMApprovalTableHeading.map((item) => {
                  return (
                    <TableCell>
                      {item.label}
                    </TableCell>
                  )
                })
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {rrmList?.map((row, index) => (
                <TableRow key={index} className={classes.tableRow}>
                  <TableCell>
                    <span className="textStyle">
                      <a href
                        className="vin"
                        onClick={() => openConditionReport(row.vin, row)}
                      >
                        {" "}
                        {row.vin}
                      </a>
                    </span>
                  </TableCell>
                  <TableCell>{row.modelYear}</TableCell>
                  <TableCell>{row.make}</TableCell>
                  <TableCell>{row.model}</TableCell>
                  <TableCell>{row.auction}</TableCell>
                  <TableCell>
                    {row?.mmr ?
                      <CurrencyFormat
                        value={parseFloat(row.mmr).toFixed(2)}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                      />
                      : '-'}
                  </TableCell>
                  <TableCell>
                    {row?.mbp ?
                      <CurrencyFormat
                        value={parseFloat(row.mbp).toFixed(2)}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                      />
                      : '-'}
                  </TableCell>
                  <TableCell>
                    {row.pricedIffpct > 0 ? "+" + (row.pricedIffpct * 100).toFixed(0) + "%" : (row.pricedIffpct * 100).toFixed(0) + "%"}
                  </TableCell>
                  <TableCell>
                    {row?.pricedDate &&
                      `${moment(row?.pricedDate).format("MM/DD/YYYY")} ${moment(row?.pricedDate).format("hh:mm a")}`}
                  </TableCell>
                  <TableCell>{row.pricedBy}</TableCell>
                  <TableCell align="center">
                    {/* {row.approve} */}
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={row.approve}
                          onChange={() => {
                            const list = [...rrmList];
                            list[index].approve = !row.approve;
                            setCheckBoxChecked(!checkBoxChecked);
                          }}
                          checkedIcon={<Check className={classes.checkedIcon} />}
                        />
                      }
                      label=""
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box m={2} justifyContent="flex-end" display={'flex'}
          sx={{
            "& .MuiButton-root": {
              m: 5
            }
          }}>


          <Button
            className={`passButton ${classes.buttonHandle}`}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            className={`purchaseButton ${classes.buttonHandle}`}
            color="primary"
            onClick={async (e) => {
              let payload = rrmList.filter(row => row.approve).map((row) => {
                let nameInfo= localStorage.getItem('userName') || "test user";
                return {
                  "pricedDate": row.pricedDate,
                  "userName": nameInfo,
                  "vin": row.vin
                }
              })
              console.log(payload)
              if (payload?.length) {
                let apiResponse = await updateRRMactionPrice(payload);
                if (apiResponse && apiResponse?.data && apiResponse?.data?.status === "Success") {
                  const list = [...rrmList];
                  list.forEach(row => {
                    row.approve = false;
                  })
                  // list[index].approve = !row.approve;
                  setRrmListRows(list);
                  setUpdateStatus(true);
                  setTimeout(() => {
                    setUpdateStatus(null);
                    props.fireRefresh();
                  }, 3000);
                }
                else {
                  setUpdateStatus(false);
                }
                setTimeout(() => {
                  setUpdateStatus(null);
                }, 4000);
              }

            }}
          >
            Update
          </Button>

        </Box>
        <Box m={2} justifyContent="flex-end" display={'flex'}
          sx={{
            "& .MuiButton-root": {
              m: 5
            }
          }}>
          {updateStatus === true && (
            <Alert variant="outlined" severity="success">
              updated successfully!
            </Alert>
          )}

          {updateStatus === false && (
            <Alert variant="outlined" severity="error">
              updating failed!
            </Alert>
          )}

        </Box>

        {rrmListRows?.length !== 0 ? <Paginator
          label="Result per page"
          showItemsPerPage={10}
          pages={[10, 20, 30, 40]}
          data={rrmListRows}
          onChangePage={onChangePage}
          setCurrentDataPage={setCurrentDataPage}
        /> : null}
      </div>
    </>
  );
}